import React, { createContext, useContext, useEffect, useState } from "react";
import { fetchSiteSettings } from "../lib/api";

const FALLBACK = {
  shipping_fee: 2.99,
  free_shipping_threshold: 50.0,
  currency: "gbp",
  current_season: "FW26",
  current_season_tagline: "New for Fall/Winter 2026",
  hero_title: "Premium Pitch Wear.",
  hero_subtitle:
    "Football grip socks engineered for boot-lock fit, close touch and clean matchday style.",
  hero_cta_primary: "Shop Grip Socks",
  hero_cta_secondary: "View Colourways",
  social_instagram: "",
  social_tiktok: "",
  contact_email: "hello@pritch.fc",
};

// Settings are admin-editable site copy + commerce config. Cached once per
// browser session; hero/shipping copy refreshes on hard reload.
const Ctx = createContext(FALLBACK);

export const SiteSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(FALLBACK);

  useEffect(() => {
    fetchSiteSettings()
      .then((s) => setSettings({ ...FALLBACK, ...s }))
      .catch(() => {});
  }, []);

  return <Ctx.Provider value={settings}>{children}</Ctx.Provider>;
};

export const useSiteSettings = () => useContext(Ctx);
